export const remarkList = "REMARK_LIST";